import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ children, requireAuth = true, requireRole = null, allowedRoles = [] }) => {
  const { currentUser, authLoading } = useAppContext();

  // Enquanto carrega, não redirecionar
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  // Se requer autenticação e não está logado
  if (requireAuth && !currentUser) {
    toast.error('Você precisa estar logado para acessar esta página');
    return <Navigate to="/login" replace />;
  }

  // Se requer role específica e não tem
  if (requireRole && currentUser?.role !== requireRole) {
    toast.error('Você não tem permissão para acessar esta página');
    return <Navigate to="/" replace />;
  }

  // Se tem lista de roles permitidas e o usuário não está na lista
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser?.role)) {
    toast.error('Você não tem permissão para acessar esta página');
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
